import type { UseMutationResult } from '@features/redux/apis/utils';
import { useEffect } from 'react';

type SideEffectFn = (originalArgs?: Record<string, any> | unknown) => void;

type EffectMap = {
    isLoading?: SideEffectFn;
    isSuccess?: SideEffectFn;
    isError?: SideEffectFn;
    isUninitialized?: SideEffectFn;
};

interface EffectProps {
    mutationState: UseMutationResult<any>;
    effects: EffectMap;
}

// ! The typo is just in the Redux typing. The actual data has "Success" spelled correctly.
type FixedMutationState<T = any> = Omit<UseMutationResult<T>, 'isSucess'> & { isSuccess: boolean };

export const MutationEffect = ({ mutationState, effects }: EffectProps) => {
    const { isError, isSuccess, isLoading, isUninitialized, originalArgs } = mutationState as any as FixedMutationState;

    useEffect(() => {
        isSuccess && effects.isSuccess && effects.isSuccess(originalArgs);
        isLoading && effects.isLoading && effects.isLoading(originalArgs);
        isError && effects.isError && effects.isError(originalArgs);
        isUninitialized && effects.isUninitialized && effects.isUninitialized(originalArgs);
    }, [mutationState]);

    return <></>;
};
